import { CLOSE_REASONS } from '../constants/closeReasons';

export const getCloseRequisitionFormConfig = () => [
  {
    name: 'rejection_reason',
    label: '', // No label as per design
    type: 'select',
    placeholder: 'Select close reason',
    options: CLOSE_REASONS,
    isRequired: true,
    fieldProps: {
      size: 'md',
    },
  },
  {
    name: 'rejection_reason_description',
    label: 'Describe the reason for closing',
    type: 'textArea',
    placeholder: 'Enter reason',
    isConditional: true,
    conditionConfig: {
      type: 'equal',
      field: 'rejection_reason',
      value: 'others',
    },
    isRequired: true,
  },
];
